import { render, staticRenderFns } from "./WorkerLicensesView.vue?vue&type=template&id=70094534&scoped=true"
import script from "./WorkerLicensesView.vue?vue&type=script&lang=js"
export * from "./WorkerLicensesView.vue?vue&type=script&lang=js"
import style0 from "./WorkerLicensesView.vue?vue&type=style&index=0&id=70094534&prod&lang=scss"
import style1 from "./WorkerLicensesView.vue?vue&type=style&index=1&id=70094534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70094534",
  null
  
)

export default component.exports